var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.255,
    height: 14.182,
    viewBox: "0 0 20.255 14.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.807,209.693H271a1.662,1.662,0,0,0-1.575,1.735V221.84A1.663,1.663,0,0,0,271,223.575h16.8a1.663,1.663,0,0,0,1.575-1.735V211.428A1.662,1.662,0,0,0,287.807,209.693Zm0,1.157a.492.492,0,0,1,.091.008l-7.912,5.81a1.1,1.1,0,0,1-1.164,0l-7.911-5.81a.476.476,0,0,1,.091-.008h16.8Zm0,11.568H271a.553.553,0,0,1-.525-.578v-9.911l7.762,5.7a2.073,2.073,0,0,0,2.331,0l7.763-5.7v9.911A.554.554,0,0,1,287.807,222.418Z",
    transform: "translate(-269.427 -209.693)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7ebfcc13910153916ac49dc388df12f7.svg";
export { ForwardRef as ReactComponent };